import {
  Link,
  Markdown,
  PageHeader,
  Paragraph,
  Section,
  Spacer
} from '@efast_public/fjd-component-library';

export default function HelpPage() {
  return (
    <div style={{ margin: '24px 0' }}>
      <PageHeader heading="Hilfe - Technischer Support" text="" />

      <Spacer size={'l'} />

      <Section type={'section'}>
        <Section.Header header={'Service Center'} level={3} />
        <Section.Content>
          <Paragraph>
            Unser Service Center Team steht Ihnen bei Fragen gerne zur
            Verfügung.
          </Paragraph>
          <Paragraph>So erreichen uns:</Paragraph>
          <Spacer size={'s'} />
          <Paragraph>
            Montag bis Donnerstag von 9:00 Uhr bis 17:00 Uhr
          </Paragraph>
          <Paragraph>Freitag von 9:00 Uhr bis 16:00 Uhr</Paragraph>
          <Spacer size={'s'} />
          <Paragraph>telefonisch unter 089 / 990236 -99</Paragraph>
          <Paragraph>
            <Markdown>
              oder über E-Mail an **[service@fjd.de](mailto:service@fjd.de)**
            </Markdown>
          </Paragraph>
        </Section.Content>
      </Section>

      <Spacer size={'5xl'} />

      <Section type={'section'}>
        <Section.Header header={'Beratungstermin'} level={3} />
        <Section.Content>
          <Paragraph>
            Gerne können Sie einen persönlichen Beratungstermin vereinbaren:
          </Paragraph>
          <Link
            beforeIcon="calendar"
            href={
              'https://outlook.office365.com/book/DigitalisierungmitEFASTKopie@fjd.de/?login_hint'
            }
            target="_blank"
          >
            <u>Jetzt einen Beratungstermin buchen</u>
          </Link>
        </Section.Content>
      </Section>

      <Spacer size={'5xl'} />

      <Section type={'section'}>
        <Section.Header header={'Dokumentation'} level={3} />
        <Section.Content>
          <Paragraph>
            Eine Dokumentation für den Online-Dienst Manager wird in Kürze
            bereitgestellt. Bitte wenden Sie sich bei Fragen hierzu in der
            Zwischenzeit an das Team des Service Centers.
          </Paragraph>
          <Paragraph>
            Das Benutzerhandbuch für den Expertenmodus (bisher StartApp) können
            Sie unter folgendem Link einsehen:
          </Paragraph>
          <Link
            beforeIcon="notebook"
            href={'https://cloud.fjd.de/index.php/s/U5K4bpQEqwxcZux'}
            target="_blank"
          >
            <u>Zum Benutzerhandbuch für den Expertenmodus (StartApp)</u>
          </Link>
        </Section.Content>
      </Section>
    </div>
  );
}
